<template>
  <div class="adList">
    <RentalObjectAd
      v-for="(data, index) in ads"
      :key="data.letting.id"
      :iM="data.iM"
      :landlord-id="landlordId"
      :letting="data.letting"
      :class="{ 'mt-4': index > 0 }"
      @publish-to-finn="lettingId => $emit('publish-to-finn', lettingId)"
    />
  </div>
</template>

<script>
import Vue from 'vue';
import BlockContainer from '@/components/BlockContainer.vue';
import RentalObjectAd from '@/components/detailedRentalObject/interestManagement/RentalObjectAd.vue';

export default Vue.extend({
  name: 'AdList',
  props: {
    landlordId: {
      type: [Number, String],
      required: true,
    },
    ads: {
      type: Array,
      required: true,
    },
  },
  components: {
    BlockContainer,
    RentalObjectAd,
  },
});
</script>
